// ── Household / guardianship links ──────────────────────────────────
// A guardian client (parent/guardian) may switch into a relative's profile in
// the client portal. Relatives are account-less Client rows created by the
// coach; the coach can switch a link off (`coachEnabled`).
/** Header the client portal sends to act as a linked household member. */
export const ACTING_CLIENT_HEADER = 'x-acting-client';
/**
 * Client code: `L-1234` / `NRA-1234`, optionally with a dependent suffix
 * (`L-1234-1`) that marks the person as part of the `L-1234` household.
 */
export const CLIENT_CODE_REGEX = /^(L|NRA)-\d{1,10}(-\d{1,3})?$/;
const SUFFIX_REGEX = /^((?:L|NRA)-\d{1,10})-(\d{1,3})$/;
/** `L-1234-2` → `L-1234`; a code without a suffix is returned unchanged. */
export function clientCodeFamilyBase(code) {
    const m = SUFFIX_REGEX.exec(code);
    return m ? m[1] : code;
}
/**
 * Next free dependent code for a household: `nextDependentCode('L-1234', [])`
 * → `L-1234-1`; with `L-1234-1` taken → `L-1234-2`. `baseCode` may itself be a
 * dependent code — the suffix is stripped first.
 */
export function nextDependentCode(baseCode, existingCodes) {
    const base = clientCodeFamilyBase(baseCode);
    let max = 0;
    for (const code of existingCodes) {
        const m = SUFFIX_REGEX.exec(code);
        if (m?.[1] === base)
            max = Math.max(max, Number(m[2]));
    }
    return `${base}-${max + 1}`;
}
//# sourceMappingURL=guardianships.js.map